var $ = jQuery;
var MigrationProgressStage = Backbone.Model.extend( {
	defaults: {
		status: 'queued',
		_initialItems: null,
		items: null,
		names: null,
		lookupItems: null,
		totalSize: 0,
		totalTransferred: 0,
		dataType: 'local',
		name: '',
		itemsComplete: 0,
		itemsCompleteArr: [],
		strings: null
	},
	initialize: function() {
		this.initStrings();

		this.set( '_initialItems', this.get( 'items' ).slice() );
		this.set( 'items', [] );
		this.set( 'names', [] );
		this.set( 'lookupItems', {} );
		this.set( 'itemsCompleteArr', [] );

		_.each( this.get( '_initialItems' ), function( item ) {
			this.addItem( item.name, item.size, item.rows );
		}, this );

		this.on( 'view:initialized', this.triggerItemViewInit );

		this.on( 'change', function() {
			wpmdb.current_migration.updateTitleElem();
		} );
	},
	initStrings: function() {
		var default_strings = {
			stage_title: this.get( 'name' ),
			migrated: wpmdb_strings.migrated,
			queued: wpmdb_strings.queued,
			active: wpmdb_strings.running,
			complete: wpmdb_strings.complete,
			hide: wpmdb_strings.hide,
			show: wpmdb_strings.show,
			itemsName: wpmdb_strings.tables
		};
		var strings = this.get( 'strings' );

		strings = ('object' === typeof strings) ? strings : {};
		strings = $.extend( default_strings, strings );

		strings.items_migrated = strings.itemsName + ' ' + strings.migrated;
		strings.hide_items = strings.hide + ' ' + strings.itemsName;
		strings.show_items = strings.show + ' ' + strings.itemsName;

		this.set( 'strings', strings );
	},
	addItem: function( name, size, rows, displayName ) {
		var items = this.get( 'items' );
		var names = this.get( 'names' );
		if ( ~names.indexOf( name ) ) {
			return;
		}
		names.push( name );
		var item = {
			name: name,
			size: size,
			rows: rows || size,
			stageName: this.get( 'name' ),
			transferred: 0,
			rowsTransferred: 0,
			complete: false,

			title: null,
			get $title() {
				return this.title || this.createTitleElem()
			},
			set $title( title ) {
				this.title = title
			},
			createTitleElem: function() {
				this.title = $( '<p>' ).addClass( 'item-info' )
					.append( $( '<span class="name" />' ).text( this.displayName || this.name ) )
					.append( ' ' )
					.append( $( '<span class="size" />' ).text( '(' + wpmdb.functions.convertKBSizeToHRFixed( item.size ) + ')' ) );
				return this.title
			},

			progress: null,
			get $progress() {
				return this.progress || this.createProgElem()
			},
			set $progress( prog ) {
				this.progress = prog
			},
			createProgElem: function() {
				this.progress = $( '<div class="progress-bar"/>' ).css( 'width', '0%' );
				return this.progress;
			},

			el: null,
			get $el() {
				return this.el || this.createMainElem()
			},
			set $el( el ) {
				this.el = el
			},
			createMainElem: function() {
				this.el = $( '<div class="item-progress" />' );
				this.el.append( this.$title );
				this.el.append( this.$progress );
				this.el.append( '<span class="dashicons dashicons-yes"/>' );
				this.el.attr( 'id', 'item-' + this.name );
				this.el.attr( 'data-stage', this.stageName );
				return this.el;
			},

			updateProgress( percent ) {
				var $progress = this.$progress;
				window.requestAnimationFrame( function() {
					$progress.css( 'width', percent + '%' )
				}.bind( this ) );
			},

		};

		// Only add the displayName if it's not empty
		if ( 'undefined' !== typeof(displayName) && displayName.length ) {
			item.displayName = displayName;
		}

		items.push( item );

		this.get( 'lookupItems' )[ name ] = items.length - 1;

		this.set( 'totalSize', parseFloat( this.get( 'totalSize' ) ) + parseFloat( size ) );
		this.trigger( 'item:added', item );
	},
	triggerItemViewInit: function() {
		var items = this.get( 'items' );
		var self = this;
		_.each( items, function( item ) {
			self.trigger( 'item:added', item );
		} );
	},
	getTotalSizeTransferred: function() {
		return this.get( 'totalTransferred' );
	},
	countItemsComplete: function() {
		return this.get( 'itemsComplete' );
	},
	getTotalProgressPercent: function() {
		var transferred = this.getTotalSizeTransferred();
		var total = this.get( 'totalSize' );
		if ( 0 >= transferred || 0 >= total ) {
			return 0;
		}
		const percent_transferred = Math.min( 100, Math.round( (transferred / total) * 100 ) );
		return percent_transferred;
	},
	activateTab: function() {
		this.trigger( 'activateTab' );
		wpmdb.current_migration.model.trigger( 'change:activeStage' );
	},
	setItemComplete: function( itemName ) {

		// Guard: return if item has already been set complete
		var itemsCompleteArr = this.get( 'itemsCompleteArr' );
		if ( ~itemsCompleteArr.indexOf( itemName ) ) {
			return;
		}
		itemsCompleteArr.push( itemName );

		var item = this.getItemByName( itemName );
		var totalTransferred = this.get( 'totalTransferred' );
		var itemsComplete = this.get( 'itemsComplete' );

		this.set( 'itemsComplete', ++itemsComplete );

		totalTransferred += item.size - item.transferred;
		this.set( 'totalTransferred', totalTransferred );

		item.transferred = item.size;
		item.complete = true;
		item.rowsTransferred = item.rows;

		this.trigger( 'change change:items', item );
	},
	setItemPercentTransferred( itemName, percentTransferred, batchSize, folderTransferred ) {
		let item = this.getItemByName( itemName );
		let transferred = batchSize / 1000;

		if ( 1 === percentTransferred ) {
			item.complete = true;
			item.transferred = transferred;
			let itemsComplete = this.get( 'itemsComplete' );
			this.set( 'itemsComplete', ++itemsComplete );
			this.trigger( 'change change:items', item );
		}
		item.transferred = folderTransferred / 1000;
		item.exactPercent = percentTransferred;
		let total_transferred = this.get( 'totalTransferred' );
		total_transferred += transferred;

		this.set( 'totalTransferred', total_transferred );
		this.trigger( 'change change:items', item );
	},
	setItemRowsTransferred: function( itemName, numRows ) {
		var amtDone, estTransferred;
		var item = this.getItemByName( itemName );
		var totalTransferred = this.get( 'totalTransferred' );

		if ( -1 === parseInt( numRows ) ) {
			amtDone = 1;
		} else {
			amtDone = Math.min( 1, numRows / item.rows );
		}

		if ( 1 === amtDone ) {
			this.setItemComplete( itemName );
			return;
		}

		estTransferred = item.size * amtDone;

		totalTransferred += estTransferred - item.transferred;
		this.set( 'totalTransferred', totalTransferred );

		item.transferred = estTransferred;
		item.rowsTransferred = numRows;
		this.trigger( 'change change:items', item );
	},
	getItemByName: function( itemName ) {
		var item = this.get( 'items' )[ this.get( 'lookupItems' )[ itemName ] ] || {};
		if ( itemName === item.name ) {
			return item;
		} else {
			return this.determineItemByName( itemName );
		}
	},
	determineItemByName: function( itemName ) {
		var items = this.get( 'items' );
		for ( var index = 0; index < items.length; index++ ) {
			var item = items[ index ];
			if ( itemName === item.name ) {
				this.get( 'lookupItems' ).itemName = index;
				return item;
			}
		}
	}
} );

module.exports = MigrationProgressStage;



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/modules/MigrationProgressStage-model.js